// ** Third party components
import { useTranslation } from "react-i18next";

// ** Components
import { ButtonSecondary } from "components/layout/Button/ButtonSecondary";
import Block from "components/layout/Block";
import Loader from "components/layout/Loader";

// ** Utils
import pseudoFormat from "utils/pseudoFormat";

// #################################################################

const LoadMoreInteractiveCommentsBtn = ({
	isAuth,
	commentsList,
	fetchComments,
	loadingComments,
	showComments = true,
}) => {
	const { t } = useTranslation(["common"]);

	// #################################################################

	if (
		!isAuth ||
		commentsList.data.length >= commentsList.total ||
		!showComments ||
		(loadingComments && !commentsList.data.length)
	) {
		return null;
	}

	if (loadingComments && commentsList.data.length) {
		return (
			<Block
				flex
				justifyCenter
				mt={3}
				alignCenter
				style={{ paddingBottom: "3px", paddingTop: "2px" }}
			>
				<Loader />
			</Block>
		);
	}

	return (
		<Block flex justifyCenter mt={3}>
			<ButtonSecondary
				label={t("common:loadMoreComments", {
					count: pseudoFormat(
						commentsList.total - commentsList.data.length
					),
				})}
				onClick={() => {
					fetchComments({
						lastId: commentsList.data[commentsList.data.length - 1]
							.id,
						limit: 10,
					});
				}}
				disabled={loadingComments}
			/>
		</Block>
	);
};

// #################################################################

export default LoadMoreInteractiveCommentsBtn;

// #################################################################
